var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViewDetails(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 2.25H8C5.93 2.25 4.25 3.93 4.25 6V6.25H3C2.59 6.25 2.25 6.59 2.25 7C2.25 7.41 2.59 7.75 3 7.75H4.25V11.25H3C2.59 11.25 2.25 11.59 2.25 12C2.25 12.41 2.59 12.75 3 12.75H4.25V16.25H3C2.59 16.25 2.25 16.59 2.25 17C2.25 17.41 2.59 17.75 3 17.75H4.25V18C4.25 20.07 5.93 21.75 8 21.75H16C18.07 21.75 19.75 20.07 19.75 18V6C19.75 3.93 18.07 2.25 16 2.25ZM18.25 18C18.25 19.24 17.24 20.25 16 20.25H8C6.76 20.25 5.75 19.24 5.75 18V6C5.75 4.76 6.76 3.75 8 3.75H16C17.24 3.75 18.25 4.76 18.25 6V18Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.02 11.85C14.47 11.36 14.75 10.71 14.75 10C14.75 8.48 13.52 7.25 12 7.25C10.48 7.25 9.25 8.48 9.25 10C9.25 10.72 9.53 11.36 9.98 11.85C8.94 12.52 8.25 13.68 8.25 15V16C8.25 16.41 8.59 16.75 9 16.75C9.41 16.75 9.75 16.41 9.75 16V15C9.75 13.76 10.76 12.75 12 12.75C13.24 12.75 14.25 13.76 14.25 15V16C14.25 16.41 14.59 16.75 15 16.75C15.41 16.75 15.75 16.41 15.75 16V15C15.75 13.68 15.06 12.52 14.02 11.85ZM10.75 10C10.75 9.31 11.31 8.75 12 8.75C12.69 8.75 13.25 9.31 13.25 10C13.25 10.69 12.69 11.25 12 11.25C11.31 11.25 10.75 10.69 10.75 10Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewDetails);
export default __webpack_public_path__ + "static/media/view-details.663608c3502ccf37a27783227dd9c302.svg";
export { ForwardRef as ReactComponent };